import { useAsync } from "./useAsync";
import * as api from "../lib/api";

/** Fetch the one announcement banner shown on the homepage. */
export function useActiveBanner() {
  return useAsync(() => api.getActiveBanner(), []);
}

/** Fetch all banners (admin). No caching — always fresh. */
export function useAdminBanners() {
  return useAsync(() => api.getBanners(), []);
}
